<template>
  <div
    class="rounded-t bg-white mb-0 px-6 py-6 flex justify-between uppercase font-bold items-center"
  >
    <button @click="handleGoBack" class="flex">
      <IconChevronLeft />
      <h3>Create a new blog</h3>
    </button>
    <div class="text-center flex justify-end items-center">
      <button
        :disabled="!validationStatus"
        :class="
          validationStatus
            ? 'bg-emerald-500 text-white active:bg-emerald-600'
            : 'bg-gray-200 text-white active:bg-gray-300'
        "
        class="mr-8 inline-flex items-center font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
        type="button"
        @click="handleCreate"
      >
        Save
        <IconSync class="animate-spin" v-if="getInstanceCreateLoading" />
      </button>
    </div>
  </div>
</template>

<script>
import IconChevronLeft from "@/assets/icons/IconChevronLeft";
import { mapGetters } from "vuex";
import IconSync from "@/assets/icons/IconSync";

export default {
  name: "BlogCreatePageHeader",
  components: {
    IconChevronLeft,
    IconSync
  },
  props: {
    handleCreate: {
      type: Function,
      required: true
    },
    validationStatus: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters(["getInstanceCreateLoading"])
  },
  methods: {
    handleGoBack() {
      this.$router.back();
    }
  }
};
</script>
